module.exports = __webpack_public_path__ + "Ubuntu-Regular.2505bfbd9bde14a7829c.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-Regular.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-Regular.ttf
// module chunks = styles